import React, { Fragment } from 'react';
import useGlobal from '../../../store';

const VideoLoader = ({ children, setProgress, setUrl }) => {

  const [ globalState, globalActions ] = useGlobal();
  const { videos } = globalActions;

  const uniq = Math.trunc( Math.random( 0, 1 ) * 1000 );

  const handleLoad = async ( e ) => {

    e.preventDefault();

    const newFiles = e.target.files;

    let readers = []; 
    let readers_count = 0;

    Array.from(newFiles).forEach(( file, index ) => {
        
      readers_count++;
      readers[ index ] = new FileReader();
      readers[ index ].readAsDataURL(file);
      readers[ index ].onloadend = async () => {

        readers_count--;

        if ( readers_count === 0 ) {

          const { video, preview } = await videos.upload( e, newFiles, setProgress );
          setUrl( video, preview );
        
        }
          
      };

    });    

  }

  return (

    <Fragment>

      <input

        type = "file" 
        multiple = { false } 
        name = "video" 
        id = {`video-upload-${uniq}`}
        onChange = { handleLoad } 
        accept = "video/mp4,video/x-m4v,video/*"

      />

      <label htmlFor = {`video-upload-${uniq}`}>
        
        { children }

      </label>

    </Fragment>

  );

}

export default VideoLoader;